import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { removeSlowInternetToast } from 'modules/conference/actions/connectionMeter';

import InternetMeterToastPlace from './InternetMeterToastPlace';


const mapStateToProps = (state) => ({
  isNeedToShowToast: state.conference.internetMeter.isNeedToShowToast,
});

export default compose(connect(mapStateToProps, { removeSlowInternetToast }))(injectIntl(InternetMeterToastPlace));
